module.exports = __webpack_public_path__ + "img/reward-btn2.463470cf.png";